import { render, staticRenderFns } from "./GfRoster.vue?vue&type=template&id=6e820682&scoped=true&"
import script from "./GfRoster.vue?vue&type=script&lang=js&"
export * from "./GfRoster.vue?vue&type=script&lang=js&"
import style0 from "./GfRoster.vue?vue&type=style&index=0&id=6e820682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e820682",
  null
  
)

export default component.exports